<template>
    <div>
        <el-table :max-height="height" :data="groupCrafts">
            <el-table-column width="80" label="图片">
                <template slot-scope="{row}">
                    <el-image
                            style="width: 65px; height: 65px"
                            :src="row.base_info.image_url"
                            alt="图片"
                            fit="contain">
                    </el-image>
                </template>
            </el-table-column>

            <el-table-column width="120" label="订单编号/款号" prop="the_id">
                <template slot-scope="{row}">
                    <div>
                        <span>{{ row.the_id }}</span>
                    </div>
                    <div>
                        <el-link target="_blank" :href="row.base_info.url" type="primary">{{ row.base_id }}</el-link>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="90" align="center" label="分派单编号" prop="id"></el-table-column>
            <el-table-column width="100" align="center" label="小组" prop="produce_group_name"></el-table-column>
            <el-table-column width="100" align="center" label="工艺" prop="craft_name">
                <template slot-scope="{row}">
                    <el-tag size="mini" type="primary">{{ row.craft_name }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" width="160" label="起止日期">
                <template slot-scope="{row}">
                    <div>{{ row.actual_start }}</div>
                    <div>{{ row.actual_end }}</div>
                </template>
            </el-table-column>

            <el-table-column width="80" align="center" label="计划数量" prop="plan_num"></el-table-column>
            <el-table-column width="80" align="center" label="上报数量" prop="finish_num"></el-table-column>
            <el-table-column width="80" align="center" label="报次数量" prop="scrap_num"></el-table-column>
            <el-table-column width="100" align="center" label="工价">
                <template slot-scope="{row}">
                    <craft-price-clo :groupCraft="row"></craft-price-clo>
                </template>
            </el-table-column>
            <el-table-column width="90" aling="center" prop="use_time" label="用时"></el-table-column>
            <el-table-column width="90" aling="center" prop="remarks" label="备注">
                <template slot-scope="{row}">
                    <div v-if="row.remarks.length > 0">
                        <el-popover
                                placement="left"
                                width="400"
                                trigger="hover">
                            <el-timeline>
                                <el-timeline-item
                                        v-for="(remark, index) in row.remarks"
                                        :key="index"
                                        :timestamp="remark.created_time">
                                    <span>{{remark.created_user}}</span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span>{{remark.remark}}</span>
                                </el-timeline-item>
                            </el-timeline>
                            <el-badge slot="reference" style="margin:10px 0" :value="row.remarks.length" class="item">
                                <el-tag size="small" type="danger">备注</el-tag>
                            </el-badge>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="90" aling="center" label="结算状态">
                <template slot-scope="{row}">
                    <el-tag size="mini" type="info" v-if="row.finance_status === -1">
                        <span>{{ row.finance_status_display }}</span>
                    </el-tag>
                    <el-tag size="mini" type="danger" v-if="row.finance_status === 0">
                        <span>{{ row.finance_status_display }}</span>
                    </el-tag>
                    <el-tag size="mini" type="success" v-if="row.finance_status === 1">
                        <span>{{ row.finance_status_display }}</span>
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="功能区">
                <template slot-scope="{row}">
                    <el-button @click="modifyGroupCraft(row)" size="mini" type="primary">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <group-order-modify ref="groupOrderModify"></group-order-modify>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GroupOrderModify from "./GroupOrderModify"
    import CraftPriceClo from "./CraftPriceClo"

    export default {
        name: "GroupOrderTable",
        components: {GroupOrderModify, CraftPriceClo},
        data() {
            window.onresize = () => {
                this.height = document.documentElement.clientHeight - 180
            }
            return {
                height: 0,
            }
        },
        computed: {
            groupCrafts() {
                return this.groupCraftData['groupCraftArray']
            },
            ...mapGetters(['groupCraftData'])
        },
        methods:{
            modifyGroupCraft(groupCraft){
                this.$refs.groupOrderModify.open(groupCraft)
            },
        },
        created() {
            this.height = document.documentElement.clientHeight - 180
        }
    }
</script>

<style scoped>

</style>